// Labels every team profile shares, Polish: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Dane osobowe',
    rows: {
      name: 'Imię i nazwisko',
      position: 'Stanowisko',
      birthdate: 'Data urodzenia',
      nationality: 'Obywatelstwo',
      maritalStatus: 'Stan cywilny',
      location: 'Lokalizacja',
      languages: 'Języki',
      programmingLanguages: 'Języki programowania',
      certifications: 'Certyfikaty',
      publications: 'Publikacje',
      links: 'Strona internetowa'
    }
  },
  education: {
    title: 'Wykształcenie'
  },
  skills: {
    title: 'Kompetencje specjalistyczne'
  },
  experience: {
    title: 'Projekty i działalność',
    techLabel: 'Technologie'
  },
  downloads: {
    title: 'Pobierz profil',
    deLabel: 'Pobierz profil po niemiecku',
    deDescription: 'PDF po niemiecku',
    enLabel: 'Pobierz CV po angielsku',
    enDescription: 'PDF po angielsku'
  },
  cta: {
    title: 'Kontakt',
    button: 'Skontaktuj się z nami'
  },
  pdf: {
    title: 'Profil',
    personalSection: 'Dane osobowe',
    educationSection: 'Wykształcenie',
    experienceSection: 'Projekty i działalność',
    skillsLabel: 'Kompetencje'
  }
};
